import {CognitoUserPool} from "amazon-cognito-identity-js";

 const poolData = {
     UserPoolId: "us-east-1_PWGdvdE3P",
     ClientId: "5tpfebbp26kdr2foh742uv3pro",
     storage: window.localStorage
 }
const cognitoUserPool = new CognitoUserPool(poolData);

export default cognitoUserPool;
